<script>
import { $themeConfig } from '@themeConfig'
export default {
    computed: {
        link() {
            return $themeConfig.app.googleUserDataPolicy;
        },
        translation() {
            if (this.$i18n.locale === 'sv') {
                return 'Google API Services User Data Policy';
            }

            return 'Google API Services User Data Policy';
        }
    }
}
</script>

<template>
    <span><a :href="link" target="_blank">{{ translation }}</a></span>
</template>
